<template>
  <div class="footer">版权所有：中国医院协会病案管理专业委员会 艾登科技</div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.footer {
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: rgba(118, 118, 118, 1);
  margin: 45px 0 10px 0;
  line-height: 39px;
}
</style>